/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { useEffect, useState } from "react";
import { Typography, Link } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { SimpliCityAdminSDK } from "@simplicitycms/simplicity-admin-js-sdk";
import { modalColumnDefinitions } from "cms/components/layout/reuse/placements-dialog/datagrid-config";
import { useAuth } from "cms/auth/hooks/use-auth";
import { isArrayNotEmpty } from "utils/empty-exists";
import { Logger } from "cms/utils/log/logger";

const ComponentPlacements = (props) => {
    
    const { component } = props;
    // const { guid, reuse_count = 0 } = component || {}
    const { guid } = component || {};
    const { token } = useAuth();
    
    const [rows, setRows] = useState([]);
    const [reuseCount , setReuseCount] = useState(0);

    useEffect(() => {
        const fetchComponents = async () => {
            try {
                const data = await SimpliCityAdminSDK.component.getComponentUsage(token, guid);
                setRows(
                    data.map((row, idx) => {
                        row.id = idx;
                        row.status = "Published";
                        return row;
                    }),
                );
                if (isArrayNotEmpty(data)) {
                    setReuseCount(data.length);
                }
            } catch (error) {
                Logger.error(error);
            }
        };
        fetchComponents();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const dataGridProps = {
        pageSize: 5,
        autoHeight: true,
        rows: rows,
        columns: modalColumnDefinitions.map((def) => {
            if (def.field === "nav_title") {
                def.renderCell = (params) => {
                    return (
                        <Link
                            underline='none'
                            href={`/composer/${params.row.guid}`}
                            target='_new'
                        >
                            {params.row.nav_title}
                        </Link>
                    );
                };
            }
            return def;
        }),
        density: "compact",
    };
    const paginationModel = { page: 0, pageSize: 5 };
    
    return (
        <div
            style={{
                display: "flex",
                flexDirection: "row",
                height: "100%",
                gap: "2em",
                width: "670px",
            }}
        >
            <div style={{ flex: "1", paddingTop: "22px", width: "100%" }}>
                <Typography
                    variant='subtitle1'
                    color='text.secondary'
                    component='div'
                    sx={{ fontWeight: "400", paddingBottom: "16px" }}
                >
                    {/*This component is reused <strong>{usage?.length} times</strong> in the following locations.*/}
                    This component is reused <strong>{reuseCount} times</strong> in the following locations.
                </Typography>
                
                <DataGrid
                    {...dataGridProps}
                    initialState={{
                        pagination: {
                            paginationModel: {
                                pageSize: 5,
                            },
                        },
                    }}
                    paginationModel={paginationModel}
                    pageSizeOptions={[5, 10, 25]}
                />
                
            </div>
        </div>
    );
};

export { ComponentPlacements };
